import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetAdmin } from '../../EndPoints';
import { EventRepresentation, EventRepresentationFilters } from '../../../models/EventRepresentation';

const useEventRepresentationService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetRepresentations, setFetchingGetRepresentations] = useState(false);
    const [fetchingStoreRepresentation, setFetchingStoreRepresentation] = useState(false);
    const [fetchingEditRepresentation, setFetchingEditRepresentation] = useState(false);
    const [fetchingUpdateRepresentation, setFetchingUpdateRepresentation] = useState(false);
    const [fetchingActiveRepresentation, setFetchingActiveRepresentation] = useState(false);
    const [fetchingDeleteRepresentation, setFetchingDeleteRepresentation] = useState(false);

    const getRepresentations = (filters: EventRepresentationFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin('events/event-representations')}?${queryString}`,
            setFetching: setFetchingGetRepresentations
        });
    };

    const storeRepresentation = (representation: EventRepresentation, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetAdmin('events/event-representations/store')}`,
            type: 'admin',
            body: representation,
            setFetching: setFetchingStoreRepresentation
        });
    };

    const editRepresentation = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-representations/${id.toString()}/edit`)}`,
            setFetching: setFetchingEditRepresentation
        });
    };

    const updateRepresentation = (id: number, representation: EventRepresentation, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-representations/${id.toString()}/update`)}`,
            body: representation,
            setFetching: setFetchingUpdateRepresentation
        });
    };

    const activeRepresentation = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-representations/${id.toString()}/active`)}`,
            body: { active: active },
            setFetching: setFetchingActiveRepresentation
        });
    };

    const deleteRepresentation = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-representations/${id.toString()}/delete`)}`,
            setFetching: setFetchingDeleteRepresentation
        });
    };

    return {
        fetchingGetRepresentations,
        fetchingStoreRepresentation,
        fetchingEditRepresentation,
        fetchingUpdateRepresentation,
        fetchingActiveRepresentation,
        fetchingDeleteRepresentation,
        getRepresentations,
        storeRepresentation,
        editRepresentation,
        updateRepresentation,
        activeRepresentation,
        deleteRepresentation
    };
};

export default useEventRepresentationService; 